import { type SelectedVariant } from "@root/tablescape/state";

export const intelligemsPrice = (selectedVariants: SelectedVariant[]) => {
  if (!window.igData) return null;

  return selectedVariants
    .map(({ id: variantId }) => {
      const variantPrice = window.igData?.price?.getPriceByVariantId(variantId);
      return variantPrice ? parseInt(variantPrice) * 100 : 0;
    })
    .reduce((a, b) => a + b, 0);
};

export const intelligemsCompareAtPrice = (
  selectedVariants: SelectedVariant[]
) => {
  if (!window.igData) return null;

  const discountDetected = selectedVariants.some((variant) =>
    window.igData?.price?.getComparePriceByVariantId(variant.id)
  );

  if (!discountDetected) {
    return null;
  }

  return selectedVariants
    .map(({ id: variantId }) => {
      const compareAtPrice =
        window.igData?.price?.getComparePriceByVariantId(variantId);

      if (compareAtPrice) {
        return parseInt(compareAtPrice) * 100;
      }

      const igPrice = window.igData?.price?.getPriceByVariantId(variantId);
      return igPrice ? parseInt(igPrice) * 100 : 0;
    })
    .reduce((a, b) => a + b, 0);
};
